module.exports = __webpack_public_path__ + "img/warning-icon-small.7c9babd4.svg";